import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import React from 'react';
import { COLORS } from 'shared/const/theme';

type ResultProps = {
  type: string;
  title: string;
  subtitle?: string;
};

const Result: React.FC<ResultProps> = ({ type, title, subtitle }) => {
  const ResultIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleOutlined style={{fontSize: 60, color: COLORS.SUCCESS}} />;
      case 'error':
        return (
          <CloseCircleOutlined
            color={COLORS.ERROR}
            size={80}
            style={{ color: COLORS.ERROR, fontSize: 60 }}
          />
        );
      case 'warning':
        return <ExclamationCircleOutlined style={{fontSize: 60, color: COLORS.WARNING}} />;
      case 'info':
        return <InfoCircleOutlined style={{fontSize: 60, color: COLORS.INFO}} />;
      case 'load':
        return <ClockCircleOutlined style={{fontSize: 60, color: COLORS.INFO}} />;
    }
  };

  return (
    <Flex align='center' gap={16} vertical>
      <ResultIcon />
      <Flex align='center'>
        <Typography.Text
          style={{
            fontSize: 20,
            fontWeight: 500,
            marginBottom: 8,
            textAlign: 'center'
          }}>
          {title}
        </Typography.Text>
        <Typography.Text
          style={{
            textAlign: 'center'
          }}>
          {subtitle}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};

export default Result;
